import { ORDER_SIDE, WalletType } from "../shared";
import { ServerApiErrorSchema } from "./misc";
import { z } from "zod";

export const TradePathDataSchema = z.object({
  from: z.string(),
  to: z.string(),
  pairSymbol: z.string(),
  orderSide: z.nativeEnum(ORDER_SIDE),
  precision: z.object({
    price: z.number(),
    amount: z.number(),
  }),
});

export type TradePathData = z.infer<typeof TradePathDataSchema>;

export const TradePathBySupportedTokensSchema = z.record(z.string(), z.array(TradePathDataSchema));

export type TradePathBySupportedTokens = z.infer<typeof TradePathBySupportedTokensSchema>;

export const TradePathBySupportedTokensResponseSchema = z.union([
  TradePathBySupportedTokensSchema,
  ServerApiErrorSchema,
]);
export type TradePathBySupportedTokensResponse = z.infer<typeof TradePathBySupportedTokensResponseSchema>;

export const GetBalancesSchema = z.object({
  accountId: z.coerce.number(),
  walletTypes: z
    .string()
    .transform((val) => val.split(",").map((item) => item.trim()))
    .pipe(z.array(z.nativeEnum(WalletType)))
    .optional(),
  forceRefresh: z
    .string()
    .transform((val) => val === "true")
    .optional(),
});

export type GetBalancesDtoType = z.infer<typeof GetBalancesSchema>;
